import { fromJS } from "immutable"
import { createSelector, createStructuredSelector } from "reselect"

const { LegislativeStanceType } = DjangIO.app.userdata.types

const stanceSelector = state => state.stance

export const selectStanceCustomLabels = createSelector(
    stanceSelector,
    state => state && state.get("stanceCustomLabels")
)

export const selectStanceCustomLabelByStance = stanceValue => createSelector(
    selectStanceCustomLabels,
    stanceCustomLabels => (
        (
            stanceCustomLabels
            && stanceCustomLabels
                .find(stanceCustomLabel => stanceCustomLabel.get("stance") === stanceValue)
        )
        || fromJS(LegislativeStanceType.by_value(stanceValue))
    )
)

export const createSelectorForStanceLabel = stanceValue => createSelector(
    selectStanceCustomLabelByStance(stanceValue),
    stanceCustomLabelObj => stanceCustomLabelObj.get("label")
)

export const createSelectorForStanceCustomLabelId = stanceValue => createSelector(
    selectStanceCustomLabelByStance(stanceValue),
    stanceCustomLabelObj => stanceCustomLabelObj.get("id")
)

const selectSupportLabel = createSelectorForStanceLabel(LegislativeStanceType.support.value)
const selectOpposeLabel = createSelectorForStanceLabel(LegislativeStanceType.oppose.value)
const selectUnimportantLabel = createSelectorForStanceLabel(LegislativeStanceType.unimportant.value)
const selectWatchingLabel = createSelectorForStanceLabel(LegislativeStanceType.watching.value)

const selectSupportCustomLabelId = createSelectorForStanceCustomLabelId(LegislativeStanceType.support.value)
const selectOpposeCustomLabelId = createSelectorForStanceCustomLabelId(LegislativeStanceType.oppose.value)
const selectUnimportantCustomLabelId = createSelectorForStanceCustomLabelId(LegislativeStanceType.unimportant.value)
const selectWatchingCustomLabelId = createSelectorForStanceCustomLabelId(LegislativeStanceType.watching.value)

export const selectInitialValues = createSelector(
    selectSupportLabel,
    selectOpposeLabel,
    selectUnimportantLabel,
    selectWatchingLabel,
    (
        supportLabel,
        opposeLabel,
        unimportantLabel,
        watchingLabel,
    ) => ({
        support: supportLabel,
        oppose: opposeLabel,
        unimportant: unimportantLabel,
        watching: watchingLabel,
    })
)

export const selectIsLoading = createSelector(
    stanceSelector,
    state => state.get("isLoading")
)

export const selectValuesMappedToLabels = createSelector(
    selectSupportLabel,
    selectOpposeLabel,
    selectUnimportantLabel,
    selectWatchingLabel,
    (
        supportLabel,
        opposeLabel,
        unimportantLabel,
        watchingLabel,
    ) => ({
        [LegislativeStanceType.support.value]: supportLabel,
        [LegislativeStanceType.oppose.value]: opposeLabel,
        [LegislativeStanceType.unimportant.value]: unimportantLabel,
        [LegislativeStanceType.watching.value]: watchingLabel,
    })
)

export const selectStancesWithCustomLabels = createSelector(
    selectValuesMappedToLabels,
    valueToLabelMap => (
        DjangIO.app.userdata.types.LegislativeStanceType
            .items()
            .map(stanceEnum => ({
                ...stanceEnum,
                label: valueToLabelMap[stanceEnum.value] || stanceEnum.label
            }))
    )
)

export const selectImmutableStancesWithCustomLabels = createSelector(
    selectStancesWithCustomLabels,
    stances => (
        stances.toJS
            ? stances
            : fromJS(stances)
    )
)

export const stanceOptionsConnection = createStructuredSelector({
    immutableStanceOptions: selectImmutableStancesWithCustomLabels,
    stanceOptions: selectStancesWithCustomLabels,
})

export const stanceSettingsFormConnection = createStructuredSelector({
    initialValues: selectInitialValues,
    isLoading: selectIsLoading,
    supportLabel: selectSupportLabel,
    opposeLabel: selectOpposeLabel,
    unimportantLabel: selectUnimportantLabel,
    watchingLabel: selectWatchingLabel,
    supportCustomLabelId: selectSupportCustomLabelId,
    opposeCustomLabelId: selectOpposeCustomLabelId,
    unimportantCustomLabelId: selectUnimportantCustomLabelId,
    watchingCustomLabelId: selectWatchingCustomLabelId,
})
